import React, { useCallback, useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import KskSelect from 'ksk/styledComponents/components/KskSelect/KskSelect';
import DominioGeralService, {
  DOMINIO_ITEM_VERIFICACAO_PVL_SITUACAO
} from 'services/DominioGeralService';
import {
  faCircleCheck,
  faCircleXmark,
  faBan,
  faHourglassHalf
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SelectSituacaoAnalisePVL = ({
  form,
  name,
  indexSubitem = null,
  valor,
  onChange,
  situacoesUsadas
}) => {
  const [icon, setIcon] = useState();
  const [novoValor, setNovoValor] = useState(valor?.nome || '');
  const [conjuntoSituacoesCompleto, setConjuntoSituacoesCompleto] = useState();
  const [conjuntoSituacoesFiltradas, setConjuntoSituacoesFiltradas] = useState();

  // 🔑 ÚNICA fonte da verdade
  const situacao = useWatch({
    control: form.control,
    name
  });

  const getIcon = (codigo) => {
    switch (codigo) {
      case 'ADEQUADO':
        return faCircleCheck;
      case 'INADEQUADO':
        return faCircleXmark;
      case 'PENDENTE':
        return faHourglassHalf;
      case 'NAO_SE_APLICA':
        return faBan;
      default:
        return faBan;
    }
  };

  const styleIconeELabelSelectedOption = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0px 4px'
  };

  // carrega o conjunto completo
  const loadConjuntoSituacoesCompleto = useCallback(async () => {
    try {
      if (!conjuntoSituacoesCompleto) {
        const response = await DominioGeralService.getDominio(
          DOMINIO_ITEM_VERIFICACAO_PVL_SITUACAO
        );
        setConjuntoSituacoesCompleto(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [conjuntoSituacoesCompleto]);

  useEffect(() => {
    loadConjuntoSituacoesCompleto();
  }, [loadConjuntoSituacoesCompleto]);

  // filtra situações já usadas
  useEffect(() => {
    const situacoesFiltradas = conjuntoSituacoesCompleto?.filter(
      (situacao) => !situacoesUsadas?.includes(situacao.codigo)
    );
    setConjuntoSituacoesFiltradas(situacoesFiltradas);
  }, [conjuntoSituacoesCompleto, situacoesUsadas]);

  // atualiza ícone e label quando o form muda
  useEffect(() => {
    if (situacao?.codigo) {
      setIcon(getIcon(situacao.codigo));
      setNovoValor(situacao.nome);
    }
  }, [situacao]);

  const handleChange = (event) => {
    const value = event.target.value;

    if (onChange) {
      onChange(value, indexSubitem);
    }
  };

  return (
    <KskSelect
      variant="standard"
      name={name}
      withLabel={false}
      dominio={conjuntoSituacoesFiltradas}
      form={form}
      displayEmpty
      showEmptyValue
      valueAsObject
      onChange={handleChange}
      defaultValue={valor}
      renderElement={(element) => element?.codigo ? (
        <div style={styleIconeELabelSelectedOption}>
          <FontAwesomeIcon icon={getIcon(element?.codigo)} />
          <span>{element?.nome}</span>
        </div>
      ) : (
        <span className="disabled-text italic">Selecione uma situação</span>
      )}
      style={{ minWidth: '150px' }}
    />
  );
};

export default SelectSituacaoAnalisePVL;
